import { useQuery } from '@tanstack/react-query';
import { getUrgentActiveNotices } from '../../../active-notice/service';

function useUrgentActiveNotices({
    propertyManagerId,
}: {
    propertyManagerId?: string;
}) {
    const query = useQuery({
        refetchOnWindowFocus: true,
        queryKey: ['dashboard', 'tab', 'urgent-active-notices', { propertyManagerId }],
        queryFn: () => getUrgentActiveNotices({ propertyManagerId }),
    });

    return query;
}

export { useUrgentActiveNotices };
